import { Controller } from "@hotwired/stimulus"

// The monthly / yearly switch on a price table. Both prices are already in the
// page, one of each pair hidden, so switching costs no request and works the
// same on the landing and inside a choir's settings.
export default class extends Controller {
    static targets = ["option", "price", "saving"]
    static values = { period: { type: String, default: "monthly" } }

    connect() {
        this.show(this.periodValue)
    }

    select(event) {
        this.show(event.currentTarget.dataset.period)
    }

    show(period) {
        this.periodValue = period

        this.optionTargets.forEach((option) => {
            const on = option.dataset.period === period
            option.setAttribute("aria-current", on ? "page" : "false")
        })

        this.priceTargets.forEach((price) => {
            price.hidden = price.dataset.period !== period
        })

        this.savingTargets.forEach((saving) => {
            saving.hidden = period !== "yearly"
        })
    }
}
